import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
import { grayLightColor } from '../../utils/styled-components/color-mixins/color-mixins';
var StyledDivider = styled('hr')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n  width: 100%;\n  height: 1.1px;\n  border: 0;\n  user-select: none;\n"], ["\n  background: ", ";\n  width: 100%;\n  height: 1.1px;\n  border: 0;\n  user-select: none;\n"])), grayLightColor);
StyledDivider.displayName = 'StyledDivider';
export { StyledDivider };
var templateObject_1;
//# sourceMappingURL=Divider.styled.js.map